/**
 * Badge catalog — all available badges and their metadata
 * New badge types should be added here as they are created.
 */

export const BADGES = {
  // Learning module badges (awarded per-module)
  MODULE_ORIENTATION: {
    id: 'module_orientation',
    name: 'Game On',
    description: 'Completed the Orientation learning module',
    icon: 'GraduationCap',
  },
  MODULE_LEASH_HANDLING: {
    id: 'module_leash-handling',
    name: 'Leash Pro',
    description: 'Completed the Leash Handling learning module',
    icon: 'Dog',
  },

  // Check-in badges
  FIRST_CHECKIN: {
    id: 'first_checkin',
    name: 'First Check-In',
    description: 'Submitted your first weekly check-in',
    icon: 'ClipboardCheck',
  },
  ON_A_ROLL: {
    id: 'on_a_roll',
    name: 'On a Roll',
    description: 'Submitted check-ins 3 weeks in a row',
    icon: 'Flame',
  },
  DEDICATED: {
    id: 'dedicated',
    name: 'Dedicated',
    description: 'Submitted check-ins 8 weeks in a row',
    icon: 'Gem',
  },

  // Skill badges
  FIRST_STEPS: {
    id: 'first_steps',
    name: 'First Steps',
    description: 'Completed your first skill',
    icon: 'PawPrint',
  },
  HIGH_FIVE: {
    id: 'high_five',
    name: 'High Five',
    description: 'Completed 5 skills across all programs',
    icon: 'Hand',
  },
  SKILL_MASTER: {
    id: 'skill_master',
    name: 'Skill Master',
    description: 'Completed all skills in a training program',
    icon: 'Trophy',
  },

  // Practice badges
  PRACTICE_MAKES_PERFECT: {
    id: 'practice_makes_perfect',
    name: 'Practice Makes Perfect',
    description: 'Logged your first practice session',
    icon: 'Star',
  },
  COMMITTED: {
    id: 'committed',
    name: 'Committed',
    description: 'Logged 10 practice sessions',
    icon: 'BicepsFlexed',
  },

  // Module milestone badges
  BOOKWORM: {
    id: 'bookworm',
    name: 'Bookworm',
    description: 'Completed 3 learning modules',
    icon: 'BookOpenCheck',
  },

  // Engagement badges
  SOCIAL_BUTTERFLY: {
    id: 'social_butterfly',
    name: 'Social Butterfly',
    description: 'Sent your first message to your trainer',
    icon: 'MessageCircleHeart',
  },
  MULTI_PET_PARENT: {
    id: 'multi_pet_parent',
    name: 'Multi-Pet Parent',
    description: 'Have 2 or more pets enrolled in programs',
    icon: 'House',
    hidden: true,
  },

  // Milestone badges
  SPLIT_DECISION: {
    id: 'split_decision',
    name: 'Split Decision',
    description: 'Completed a split milestone',
    icon: 'GitFork',
  },

  // Login streak badges
  COMEBACK_KID: {
    id: 'comeback_kid',
    name: 'Comeback Kid',
    description: 'Logged in 2 days in a row',
    icon: 'CalendarCheck',
  },
  CREATURE_OF_HABIT: {
    id: 'creature_of_habit',
    name: 'Creature of Habit',
    description: 'Logged in 10 days in a row',
    icon: 'Flame',
  },
  UNSTOPPABLE: {
    id: 'unstoppable',
    name: 'Unstoppable',
    description: 'Logged in 20 days in a row',
    icon: 'Zap',
  },
  WEEKEND_WARRIOR: {
    id: 'weekend_warrior',
    name: 'Weekend Warrior',
    description: 'Logged in on a weekend',
    icon: 'Sunrise',
    hidden: true,
  },

  // Practice milestone badges
  MARATHON_TRAINER: {
    id: 'marathon_trainer',
    name: 'Marathon Trainer',
    description: 'Logged 50 practice sessions',
    icon: 'Footprints',
  },
  CENTURY_CLUB: {
    id: 'century_club',
    name: 'Century Club',
    description: 'Logged 100 practice sessions',
    icon: 'Crown',
  },

  // Program milestone badges
  OVERACHIEVER: {
    id: 'overachiever',
    name: 'Overachiever',
    description: 'Completed 2 full training programs',
    icon: 'Rocket',
  },
  TRIPLE_THREAT: {
    id: 'triple_threat',
    name: 'Triple Threat',
    description: 'Completed 3 full training programs',
    icon: 'Medal',
  },

  // Hidden badges (surprise rewards)
  ACE: {
    id: 'ace',
    name: 'Ace',
    description: 'Passed a quiz on the first try with 100%',
    icon: 'Target',
    hidden: true,
  },
  EARLY_BIRD: {
    id: 'early_bird',
    name: 'Early Bird',
    description: 'Logged a practice session before 7am',
    icon: 'Sunrise',
    hidden: true,
  },
  NIGHT_OWL: {
    id: 'night_owl',
    name: 'Night Owl',
    description: 'Logged a practice session after 9pm',
    icon: 'Moon',
    hidden: true,
  },
  PET_COLLECTOR: {
    id: 'pet_collector',
    name: 'Pet Collector',
    description: 'Added 3 or more pets',
    icon: 'Cat',
    hidden: true,
  },
};

/**
 * Get badge definition by ID
 * @param {string} badgeId
 * @returns {Object|undefined}
 */
export const getBadgeById = (badgeId) =>
  Object.values(BADGES).find((b) => b.id === badgeId);
